import { Button } from "./ui/button";
import { Shield, Home, CheckCircle, LogOut } from "lucide-react";

interface NavbarProps {
    currentPage: 'register' | 'login' | 'admin' | 'tracking' | 'speaker-upload' | 'invite';
    isAuthenticated: boolean;
    userName?: string | null;
    onNavigate: (page: 'register' | 'login' | 'admin' | 'tracking' | 'speaker-upload' | 'invite') => void;
    onLogout: () => void;
}

export function Navbar({ currentPage, isAuthenticated, userName, onNavigate, onLogout }: NavbarProps) {
    return (
        <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
            <div className="container mx-auto px-4 h-16 flex items-center justify-between">
                {/* Logo / Brand */}
                <div
                    className="flex items-center gap-2 cursor-pointer"
                    onClick={() => onNavigate('register')}
                >
                    <div className="bg-[#0f2744] rounded-lg p-1.5 shadow-sm border border-[#c9a227]/20">
                        <img
                            src={`${import.meta.env.BASE_URL}escudo-icono.svg`}
                            alt="UNACH"
                            className="h-5 w-auto filter brightness-0 invert"
                        />
                    </div>
                    <div>
                        <h1 className="text-lg font-bold text-[#0f2744] leading-tight">
                            Convenciones<span className="text-[#c9a227]">CIU</span>
                        </h1>
                        <p className="text-[10px] text-gray-500 font-medium tracking-wider uppercase">
                            Universidad Autónoma de Chiapas
                        </p>
                    </div>
                </div>

                {/* Navigation Links */}
                <div className="flex items-center gap-1 md:gap-4">
                    <Button
                        variant={currentPage === 'register' ? 'default' : 'ghost'}
                        size="sm"
                        onClick={() => onNavigate('register')}
                        className={`gap-2 ${currentPage === 'register' ? 'bg-[#0f2744] hover:bg-[#1a3a5a] text-white' : 'text-gray-600'}`}
                    >
                        <Home className="h-4 w-4" />
                        <span className="hidden md:inline">Inicio</span>
                    </Button>

                    <Button
                        variant={currentPage === 'tracking' ? 'default' : 'ghost'}
                        size="sm"
                        onClick={() => onNavigate('tracking')}
                        className={`gap-2 ${currentPage === 'tracking' ? 'bg-[#0f2744] hover:bg-[#1a3a5a] text-white' : 'text-gray-600'}`}
                    >
                        <CheckCircle className="h-4 w-4" />
                        <span className="hidden md:inline">Seguimiento</span>
                    </Button>

                    {isAuthenticated ? (
                        <>
                            <div className="h-6 w-px bg-gray-200 mx-2 hidden md:block" />
                            <div className="flex items-center gap-2 md:gap-4">
                                <Button
                                    variant={currentPage === 'admin' ? 'default' : 'ghost'}
                                    size="sm"
                                    onClick={() => onNavigate('admin')}
                                    className={`gap-2 ${currentPage === 'admin' ? 'bg-[#0f2744] hover:bg-[#1a3a5a] text-white' : 'text-gray-600'}`}
                                >
                                    <Shield className="h-4 w-4" />
                                    <span className="hidden md:inline">AdminPanel</span>
                                </Button>
                                <span className="text-sm font-medium text-gray-700 hidden md:block">
                                    {userName || 'Administrador'}
                                </span>
                                <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={onLogout}
                                    className="gap-2 text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700"
                                >
                                    <LogOut className="h-4 w-4" />
                                    <span className="hidden md:inline">Salir</span>
                                </Button>
                            </div>
                        </>
                    ) : (
                        <Button
                            variant={currentPage === 'login' ? 'default' : 'ghost'}
                            size="sm"
                            onClick={() => onNavigate('login')}
                            className={`gap-2 ${currentPage === 'login' ? 'bg-[#0f2744] hover:bg-[#1a3a5a] text-white' : 'text-gray-600'}`}
                        >
                            <Shield className="h-4 w-4" />
                            <span className="hidden md:inline">Administración</span>
                        </Button>
                    )}
                </div>
            </div>
        </nav>
    );
}
